module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-grey-2-0713d19eb3df72e7f3994f50dd73573d.png";